import { call } from '../core'

export function callCenter() {
  call('finCallCenter')
}
